import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia.
export const Route = createFileRoute("/en/retail-profitability-calculator")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/calculator", statusCode: 301 });
  },
});
